import gql from 'graphql-tag';

export const PerformanceCenterTextVariationsResult = gql`
  fragment PerformanceCenterTextVariationsResult on PerformanceCenterTextVariationsResult {
    id
    text
    weightedAvgCtr
    lifetimeImpressions
    textType
    startDate
    sourceAnyword
    numberOfInstances
    keywords
    campaignNames
    lifetimeConversions
    sortIndex
    tags {
      tagName
      status
    }
  }
`;

export const FRAGMENT_CIP_TALKING_POINTS = gql`
  fragment TalkingPoint on TalkingPoint {
    name: talkingPoint
    copyTexts
    rating
  }
`;

export const FRAGMENT_REVIEWS_ACCOUNT = gql`
  fragment PerformanceCenterReviewAccount on PerformanceCenterReviewAccount {
    id
    siteType
    urls
    productTitle
  }
`;

export const FRAGMENT_WEBSITE_ACCOUNT = gql`
  fragment PerformanceCenterWebsiteAccount on PerformanceCenterWebsiteAccount {
    id
    websiteType
    urls
    pageTitles
  }
`;
